// extracted by mini-css-extract-plugin
module.exports = {"eyebrow":"styles-module--eyebrow--2-7YB","heading":"styles-module--heading--r7Ad0","bodyText":"styles-module--bodyText--aNf7n"};